export default __webpack_public_path__ + "static/media/IMG0678.111ab391.jpg";